<template>
  <div class="teacher-box">
    <!-- <img src="@/assets/Frame 594.png" alt="" /> -->
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 模块1 ------colorCards组件 -->
    <div class="box-colorCards">
      <!-- <colorCards class="colorCards" :info1= "mydata.teachingResearchMediaObj" :info2="mydata.publicBenefitUrl"></colorCards> -->
      <colorCards class="colorCards"></colorCards>
    </div>
    <!-- 模块2 ------ 合作平台 -->
    <div class="box-aboutOur">
      <div class="aboutOur-left">
        <textBar class="textBar1" titles="合作平台"></textBar>
        <!-- <aboutOurCards :info= "mydata.cooperationPlatformObj" path="/layout/list/cooperatePlate"> </aboutOurCards> -->
        <aboutOurCards path="/layout/list/cooperatePlate"> </aboutOurCards>
      </div>

      <div class="aboutOur-right">
        <activityResultsCard title="推荐成果" :ele_have_scrollbar="true">
          <template #abc>
            <rowBookCards
              class="myRowBookCards"
              v-for="(item, index) in mydata.articleListRecommend"
              :key="index"
              @click="fnfn(item.id)"
              :info="{ title: item.title, description: item.intro }"
            >
              <template #rowBook>
                <img v-complete:src="item.image" style="border-radius: 5px" />
              </template>
            </rowBookCards>
          </template>
        </activityResultsCard>
      </div>
    </div>
    <!-- 模块3 ------ 研究项目 -->
    <div class="box-research">
      <textBar class="textBar2" titles="课题研究">
        <template #abc>
          <p
            class="check-more"
            style="cursor: pointer"
            @click="router.push({ path: '/layout/list/research' })"
          >
            查看更多<el-icon><ArrowRight /></el-icon>
          </p>
        </template>
      </textBar>
      <div class="research-projects">
        <swiperImg3
          :dataArr="mydata.articleListArr"
          @itemClick="swiperItemClick2"
          :key="mydata.testKey2"
        >
        </swiperImg3>

        <!-- <researchProjects
          class="min-box"
          :path="mydata.path"
          v-for="(item, index) in mydata.articleListArr"
          :key="index"
          :info="item"
        >
        </researchProjects> -->
      </div>
    </div>
    <!-- 模块4 ------ 新书推荐 -->
    <div class="box-newBooks">
      <textBar class="textBar3" titles="新书推荐"></textBar>
      <div>
        <!-- 轮播图图片组件 -->
        <swiperImg :dataArr="mydata.bookNew" @itemClick="fn"></swiperImg>
      </div>
    </div>
  </div>
</template>

<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import colorCards from "@/components/colorCards/index.vue";
import activityResultsCard from "@/components/activityResultsCard/index.vue";
import rowBookCards from "@/components/rowBookCards/index.vue";

import textBar from "@/components/textBar/index.vue";

import aboutOurCards from "@/components/aboutOurCards/index.vue";

// import researchProjects from "@/components/researchProjects/index.vue";
import swiperImg3 from "@/components/swiperImg3/index.vue";

import { ArrowRight } from "@element-plus/icons-vue";

// import researchCard from "@/components/researchCard/index.vue";

// import column from "@/components/column/index.vue";
// 引入接口
import { articleList } from "@/api/home/index.js";
import { reactive, toRaw } from "vue";
// 引入接口
import { getUrlId } from "@/utils/slide.js";
import { bookNew } from "@/api/addedServices/index.js";
// import { teachingAssistantList } from "@/api/teacherHand/index.js";

import { useRouter, useRoute } from "vue-router";
import swiperImg from "@/components/swiperImg/index.vue";

//swiper start//////////////////////////////////////////////////////////////////////////////////////////////
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";
//swiper end//////////////////////////////////////////////////////////////////////////////////////////////

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  path: "/layout/list/researchDetails",
  articleListArr: [], // 文章列表
  articleListRecommend: [], // 推荐成果
  form: {
    column_id: getUrlId(route.path), // 栏目id值
    // search: "", // 搜索查询
    // stage: "", //学段
    // theme: "", //主题
    // subject: "", //学科
  },
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  bookNew: [], // 新书推荐

  testKey: new Date().getTime() - Math.random(),

  // teachingResearchMediaObj:{}, //教研合作媒体
  // publicBenefitUrl:"", //支持公益项目
  // cooperationPlatformObj:{},//合作平台
});

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  swiperNew.slidePrev();
};
// 点击左箭头
const leftClick = () => {
  swiperNew.slideNext();
};
// 单元块滑动
const onSlideChange = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

// 推荐成果
function articleListRecommendFN() {
  articleList({ column_id: getUrlId("/layout/list/projectAchievements") }).then(
    (res) => {
      mydata.articleListRecommend = res.data.list;
    }
  );
}
articleListRecommendFN();

// 新书推荐
function bookNewFN() {
  bookNew().then((res) => {
    mydata.bookNew = res.data.list;
  });
}
bookNewFN();

// 获取文章列表
function articleListFn() {
  // 记得传递参数
  articleList({
    column_id: getUrlId("/layout/list/research"), // 栏目id值
    page: "1",
    psize: "3",
    search: "",
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
  });
}

// 查询
articleListFn();

//教书助手杂项  旧接口
// function teachingAssistantFn(){
//   teachingAssistantList({}).then((res)=>{
//     //  console.log(res.data,"教研合作媒体")
//      mydata.teachingResearchMediaObj = res.data.teaching_research_media  //教研合作媒体
//      mydata.publicBenefitUrl = res.data.public_benefit_url    //支持公益项目
//      mydata.cooperationPlatformObj = res.data.cooperation_platform   //合作平台
//      //mydata.teachingAssistantArr = res.data
//   })
// }

// teachingAssistantFn()

//新书推荐点击事件
function fn(item) {
  // console.log(item)
  router.push({
    path: "/layout/list/booksDetails",
    query: { id: item.id },
  });
}

//推荐成果点击事件
function fnfn(id) {
  router.push({
    path: "/layout/list/worksDisplayDetails",
    query: { id },
  });
}

function swiperItemClick2(val) {
  router.push({
    path: "/layout/list/researchDetails",
    query: { id: val.id },
  });
}
</script>

<style scoped lang="scss">
.teacher-box {
  background-color: #f9f9f9;
  // background-color: #ffffff;
  padding-bottom: 40px !important;

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  //////模块1------colorCards组件
  .box-colorCards {
    margin: 0 auto;
    margin-top: 16px;
    // margin-left: 16px;
    // margin-right:16px;
    // width: 343px !important;
    // height: 397px;
    // border: 1px solid rgb(0, 115, 255);
    display: flex;
    // justify-content: space-between;

    margin-bottom: 24px;
    // overflow-x: auto;
  }
  //////模块2------合作平台 、推荐成果
  .box-aboutOur {
    width: 343px;
    // height: 564px;
    // border: 1px solid red;
    margin: 0 auto;
    // display: flex;
    overflow: hidden;
    //////模块2的  ------左边
    .aboutOur-left {
      width: 343px;
      // height: 100%;
      // border: 1px solid pink;
      margin-bottom: 40px;
      // overflow: hidden;
      .textBar1 {
        width: 343px !important;
        // border: 1px solid blue;
        margin-top: 0px;
        // margin-bottom: 30px;
      }
    }
    //////模块2的  -----右边activityResults组件
    .aboutOur-right {
      width: 343px;
      height: 100%;
      // border: 1px solid rgb(255, 192, 203);
      //activityResultsCard组件
      :deep(.activity-results) {
        // .box-content {
        //   height: 480px;
        //   overflow: auto;
        // border:1px solid red;
        // }

        // height: 100%;
        .row-book {
          margin-bottom: 16px;
          padding-right: 0px;
          background-color: #ffffff;
          border-radius: 8px;
          display: flex;
          padding: 10px;
          // border:1px solid red;
          img {
            width: 120px !important;
            // height: 68px;
            margin-right: 10px;
            // border:1px solid red;
          }
          .box-p {
            width: 170px;
            //  margin-right:0px;
            // border:1px solid rgb(0, 4, 255);
            > p:nth-of-type(1) {
              display: -webkit-box;
              -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
              text-overflow: ellipsis; //文本溢出 用省略号显示
              -webkit-line-clamp: 2; //几行
              overflow: hidden;
            }

            // > p:nth-of-type(2) {
            //   display: none;
            // }
          }
        }
        .row-book:nth-last-of-type(1) {
          margin-bottom: 0px;
        }
      }
    }

    :deep(.myRowBookCards) {
      width: 100% !important;
    }
  }
  //////模块3------研究项目
  .box-research {
    width: 343px;
    // height: 688px;
    // border: 1px solid rgb(17, 0, 255);
    margin: 0 auto;

    :deep(.book-cards) {
      .box-tit {
        margin-bottom: 0px !important;
      }
      .box-tag {
        display: none;
      }
    }

    :deep(.swiper-wrapper) {
      // width: 365px;
      // border:1px solid red;
      height: 260px !important;
    }
  }

  //////模块4------新书推荐
  .box-newBooks {
    width: 343px;
    // height: 332px;
    // border: 1px solid rgb(17, 0, 255);
    margin: 0 auto;
    margin-top: 16px;
    // margin-bottom: 0px;
    .textBar3 {
      // width:781px !important;
      // border: 1px solid rgb(255, 0, 34);
      // margin-top: 20px;
      // margin-bottom: 30px !important;
    }
    // .books {
    //   width: 1200px;
    //   height: 270px;
    //   display: flex;
    //   justify-content: space-between;
    //   // border: 1px solid rgb(0, 255, 13);
    //   // margin: 0 auto;
    //   // background-color: #ffffff;
    //   display: flex;
    //   // flex-wrap: wrap;
    //   justify-content: space-between;
    //   // align-content: space-between; //行间距 （控制折行后的行间距）
    //   /* flex-start
    //      flex-end;
    //      center;
    //      space-between;
    //      space-around; */
    //   // .min-box {
    //   //   margin-bottom: 20px;
    //   // }
    // }
  }

  // //activityResultsCard组件
  // .box-activityResultsCard {
  //   margin: 0 auto;
  //   margin-top: 46px;
  //   width: 1202px !important;
  //   border: 1px solid rgb(0, 115, 255);
  //   display: flex;
  //   justify-content: space-between;
  // }
  // .activityResults {
  //   margin: 0 auto;
  //   margin-bottom: 40px;
  // }

  // .subject-button {
  //   width: 1202px !important;
  //   // height: 397px;
  //   border: 1px solid rgb(0, 115, 255);
  //   background-color: #ffffff;
  //   margin: 0 auto;
  //   margin-top: 61px;
  //   padding: 20px 14px 33px 14px;
  //   overflow: hidden;
  // }

  // .research-projects {
  //   width: 1202px !important;
  //   // height: 397px;
  //   border: 1px solid rgb(217, 255, 0);
  //   margin: 0 auto;
  //   background-color: #f9f9f9;
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: space-between;
  //   align-content: space-between; //行间距 （控制折行后的行间距）
  //   /* flex-start
  //        flex-end;
  //        center;
  //        space-between;
  //        space-around; */

  //   .min-box {
  //     margin-bottom: 45px;
  //   }
  // }

  // .textBar1,
  // textBar2 {
  //   margin-top: 60px;
  //   margin-bottom: 40px;
  // }
  // .textBar3 {
  //   margin-top: 15px;
  //   margin-bottom: 40px !important;
  // }

  // .research {
  //   margin-bottom: 40px;
  // }

  // .column {
  //   margin: 0 auto;
  //   margin-bottom: 40px;
  //   li {
  //     margin-left: 20px;
  //   }
  // }
}

// .bottomBar{
//   margin-top:80px;
// }

:deep(.swiper-wrapper) {
  height: 200px;
}

.l-btn {
  position: absolute;
  z-index: 9999;
  color: #ffffff;
  font-size: 20px;
  border: 1px solid #ffffff;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  top: 45%;
  left: -50px;
  background: transparent;
}

.r-btn {
  position: absolute;
  z-index: 9999;
  color: #ffffff;
  font-size: 20px;
  border: 1px solid #ffffff;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  top: 45%;
  right: -50px;
  background: transparent;
}
:deep(.r-btn[data-v-1891c10e]) {
  right: 0px;
}

:deep(.l-btn[data-v-1891c10e]) {
  left: 0px;
}
:deep(.text-bar) {
  .check-more {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }
}
</style>
